(function () {
  const SWIPER_SRC = 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.js';

  function loadSwiper() {
    if (window.Swiper) return Promise.resolve();
    if (window.tpSwiperLoadPromise) return window.tpSwiperLoadPromise;

    window.tpSwiperLoadPromise = new Promise((resolve, reject) => {
      const existingScript = document.querySelector('script[data-tp-swiper]');

      if (existingScript) {
        existingScript.addEventListener('load', resolve, { once: true });
        existingScript.addEventListener('error', reject, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = SWIPER_SRC;
      script.defer = true;
      script.dataset.tpSwiper = 'true';
      script.addEventListener('load', resolve, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });

    return window.tpSwiperLoadPromise;
  }

  if (!customElements.get('tp-review-carousel')) {
    class TpReviewCarousel extends HTMLElement {
      connectedCallback() {
        this.mediaQuery = window.matchMedia('(max-width: 749px)');
        this.handleViewportChange = this.handleViewportChange.bind(this);

        if (this.mediaQuery.addEventListener) {
          this.mediaQuery.addEventListener('change', this.handleViewportChange);
        } else {
          this.mediaQuery.addListener(this.handleViewportChange);
        }

        this.handleViewportChange();
      }

      disconnectedCallback() {
        this.destroySwiper();

        if (!this.mediaQuery) return;

        if (this.mediaQuery.removeEventListener) {
          this.mediaQuery.removeEventListener('change', this.handleViewportChange);
        } else {
          this.mediaQuery.removeListener(this.handleViewportChange);
        }
      }

      handleViewportChange() {
        if (this.mediaQuery.matches) {
          this.initializeSwiper();
        } else {
          this.destroySwiper();
        }
      }

      async initializeSwiper() {
        if (this.swiper) return;

        try {
          await loadSwiper();
        } catch (error) {
          this.dataset.swiperError = 'true';
          return;
        }

        if (!this.isConnected || !window.Swiper) return;

        const swiperElement = this.querySelector('[data-tp-review-swiper]');
        if (!swiperElement) return;

        const paginationElement = this.querySelector('[data-tp-review-pagination]');

        this.swiper = new window.Swiper(swiperElement, {
          slidesPerView: this.getNumber('slidesMobile', 1.08),
          spaceBetween: this.getNumber('spaceMobile', 16),
          watchOverflow: true,
          threshold: 8,
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },
          autoplay:
            this.dataset.autoplay === 'true'
              ? {
                  delay: this.getNumber('autoplayDelay', 4000),
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }
              : false,
          pagination: paginationElement
            ? {
                el: paginationElement,
                clickable: true,
              }
            : false,
        });
      }

      destroySwiper() {
        if (!this.swiper) return;

        this.swiper.destroy(true, true);
        this.swiper = null;
      }

      getNumber(name, fallback) {
        const value = Number(this.dataset[name]);
        return Number.isFinite(value) ? value : fallback;
      }
    }

    customElements.define('tp-review-carousel', TpReviewCarousel);
  }
})();
